// A stored index/seed selects the same mathematical configuration on replay.
export function selectExtendedVariant(configs, options = {}) {
  if (!configs.length) throw new Error("Empty extended-matura variant pool");
  let index = options.variantIndex;
  if (index == null && options.seed != null) {
    let hash = 2166136261;
    for (const char of String(options.seed)) hash = Math.imul(hash ^ char.charCodeAt(0), 16777619) >>> 0;
    index = hash % configs.length;
  }
  if (index == null) index = Math.floor(Math.random() * configs.length);
  if (!Number.isInteger(index) || index < 0 || index >= configs.length) {
    throw new RangeError("Invalid extended-matura variant index");
  }
  return { ...configs[index], variantIndex: index };
}

export function extendedMaySource(taskNumber, original = false) {
  return { variant: original ? "original" : "random", exam: "MATURA", session: "2025_MAJ",
    taskNumber: String(taskNumber), basedOn: `MMAP-R0-100-A-2505-${taskNumber}` };
}
